(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name smb-app.directive:smbadminUser
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * `sbadminInviteUsers` form to invite users to a deployment
	 *
	 * @usage
	 *
	 * <sbadmin-user deployment-id='1' user-id='1' />
	 *
	 *
	 * @element input
	 * @param {number=} userId The id of the deployment to user to view details
	 */

	angular.module('smb-app')
		.directive('smbadminUser', UserDirective)
		.controller('smbadminUserController', [
			'$state',
			'sbToastService',
			'smbToolbarService',
			'smbUserDataStore',
			'pxProgressService',
			'gettextCatalog',
			UserController
		]);

	var templateUrl = require('./user.template');
	function UserDirective() {
		return {
			restrict: 'E',
			controller: 'smbadminUserController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				userId: '@'
			},
			scope: {}
		};
	}
	function UserController($state, sbToastService, smbToolbarService, smbUserDataStore, pxProgressService, gettextCatalog) {
		var isLoading = true;
		var vm = this;

		var title = vm.userId ? gettextCatalog.getString('Edit User') : gettextCatalog.getString('Create User');
		smbToolbarService.set(title, 'useradmin.home.users');

		vm.smbUserDataStore = smbUserDataStore;
		vm.updateUserLock = updateUserLock;
		vm.submitForm = submitForm;
		vm.toastVisible = false;
		vm.errorMessage = null;

		function updateUserLock() {
			if (isLoading || !vm.userId) { return; }

			if (smbUserDataStore.user.IsLocked) {
				smbUserDataStore.lockUser(smbUserDataStore.user.UserId).then(function () {
					var message = gettextCatalog.getString('{{userName}} is now locked', { userName: smbUserDataStore.user.UserName });
					toast(message);
				});
				return;
			}

			smbUserDataStore.unlockUser(smbUserDataStore.user.UserId).then(function () {
				var message = gettextCatalog.getString('{{userName}} is now unlocked', { userName: smbUserDataStore.user.UserName });
				toast(message);
			});
		}

		function submitSuccess(response) {
			//REMOVE for ticket SBWEB-363
			if (response.Error) {
				submitFailure(response);
				return;
			}
			//end of REMOVE

			//success
			//route
			$state.go('^');

			var message = vm.userId !== null ? gettextCatalog.getString('User updated successfully') : gettextCatalog.getString('User created successfully');
			toast(message);
		}

		function submitFailure(res) {
			// Depending on what type of request we make (create or update) we will get a different type of error object
			// This function handles both expected types of objects and displays messages for those.
			// Create requests (POST) will always get 200 and some API error object, update requests will always return an HTTP error response
			// so we can use the status to determine the error
			var existsError = gettextCatalog.getString('A user with the email address {{address}} already exists', { address: smbUserDataStore.user.EmailAddress });
			if (res.status) {
				// assume HTTP error
				switch (res.status) {
					case 409:
						vm.errorMessage = existsError;
						break;
					case 500:
						// Most likely data is missing from request
						vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred, please make sure all required information has been provided');
						break;
					case 400:
						// Happens when the user does not exist
						vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred, the user you are trying to update could not be found');
						break;
					default:
						vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred. If the problem continues please contact support');
				}
			} else if (res.Error) {
				// API error object
				if (res.UserExists) {
					vm.errorMessage = existsError;
				} else if (res.InvalidPassword) {
					// Invalid password message is translated
					vm.errorMessage = res.Error;
				}
			}
			//failure
			pxProgressService.visible = false;
		}

		function submitForm() {

			if (!vm.userId) {
				//create user
				if (smbUserDataStore.user.Password !== vm.VerifyPassword) {
					vm.errorMessage = gettextCatalog.getString('Passwords do not match');
					return;
				}

				pxProgressService.backdrop = true;
				showLoader();

				vm.errorMessage = null;
				smbUserDataStore.addUser(smbUserDataStore.user)
					.then(submitSuccess, submitFailure)
					.finally(hideLoader);
				return;
			}

			pxProgressService.backdrop = true;
			showLoader();
			//update user
			smbUserDataStore.updateUser(smbUserDataStore.user).then(submitSuccess, submitFailure)
				.finally(hideLoader);
		}

		function toast(message) {
			vm.toastVisible = true;
			sbToastService.showSimple(message)
				.finally(function() {
					vm.toastVisible = false;
				});
		}

		function showLoader() {
			pxProgressService.visible = true;
		}
		function hideLoader() {
			isLoading = false;
			pxProgressService.visible = false;
		}
		//initialize
		(function loadUser() {
			pxProgressService.visible = true;

			vm.smbUserDataStore.getUser(vm.userId)
				.finally(hideLoader);
		}());
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/components/user/user.js
// module id = 100
// module chunks = 1